<template>
  <div class="servicesWrap">
    <img :src="merchantInfo.img" alt="" style="width: 100%;height: 130px;object-fit: cover;margin-bottom: 20px">
    <h3 class="servicesTitle">服务内容</h3>
    <div class="servicesPro">
      <div class="servicesProItem" v-for="item in project[service_type]">
        <h3>{{item.name}}</h3>
        <span @click="toDetail(item)">立即预约</span>
        <div class="itemDesc">{{item.desc}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import util from '@/utils';
import Data from '@/utils/data';
import { isWeiXin, isSafari } from '@/utils';
import {servicesNew} from "@/apis/rescue";
import services from "@/views/services/index.vue";



export default {
    data(){
        return {
            user_phone: localStorage.getItem('user_phone'),
            user_nick: localStorage.getItem('user_nick'),
            merchant_id: localStorage.getItem('merchant_id'),
            service_type: 1,
            merchantInfo:{
              id: '1',
              img: 'https://h5.tc-rescue.com/snServices/images/m (1).jpg',
              name: '壳牌鹏致（园洲镇鑫宝驾）',
              address: '园洲镇沙河大道69号',
              desc: "标准洗车，精致洗车，空调清洗，车内消毒"
            },
          project: {
            1: [
              {name: "汽车刹车深度保养", desc: "刹车踏板、助力器、总泵、 ABS 辅助、油管、各轮的刹车分泵及摩擦组件的深度检查", link: "/servicesDetail?type="},
              {name: "清洗冷却系统", desc: "散热器、水泵、散热器电子扇总成、节温器、水泵总成、散热器补水壶、散热器风扇、散热器下护板、散热器盖等进行检查和清洁", link: "/servicesDetail?type="},
              {name: "清洗进气系统", desc: "对车辆空气或混合气导入发动机气缸的零部件集合体进行进行检查和清洁", link: "/servicesDetail?type="},
            ],
            2: [
              {name: "标准洗车", desc: "车身外观清洗、内饰清理/除尘、脚垫清洁、玻璃清洁、轮胎轮毂清洁、外部擦干", link: "/servicesDetail?type="},
              {name: "精细洗车", desc: "高压水枪全车预冲洗、轮毂专用清洁剂浸泡分解刹车粉、仪表台、中控区、门板深度清洁、脚垫深度清洁护理", link: "/servicesDetail?type="},
            ],
            3: [
              {name: "车辆喷（补）漆", desc: "A 类：汽车喷漆一幅 (含工时费、不含钣金) ，车身价 20 万以下 B 类：汽车喷漆一幅 (含工时费、不含钣金) ，车身价 20 万至 30 万 C 类：汽车喷漆一幅 (含工时费、不含钣金) ，车身价 30 万至 50 万 D 类：汽车喷漆一幅 (含工时费、不含钣金) ，车身价 50 万至 130 万 E 类：汽车喷漆一幅 (含工时费、不含钣金) ，车身价 130 万以上", link: "/servicesDetail?type="},
              {name: "无腻子精修喷漆", desc: "汽车喷漆一幅（素色漆）、汽车喷漆一幅（银粉漆、金属漆）、汽车喷漆一幅（珍珠漆）", link: "/servicesDetail?type="},
            ],
            5: [
              {name: "车辆保养（臭氧消毒）", desc: "汽车车内消毒除菌服务", link: "/servicesDetail?type="},
              {name: "轻度钣金修复", desc: "单幅点状凹陷或＜2CM拉痕", link: "/servicesDetail?type="},
              {name: "轻度钣金无痕修复", desc: "铁质车身＜10CM凹陷、铝质车身＜10CM凹陷", link: "/servicesDetail?type="},
              {name: "汽车玻璃修复", desc: "裂点无痕修复", link: "/servicesDetail?type="},
              {name: "动力养护", desc: "按照标准的工艺更换机油和机滤，完成标准为就机油清理彻底，新机油滤清器安装妥当", link: "/servicesDetail?type="},
            ]
          }
        }
    },
    created(){
        this.service_type = this.$route.query.type;
        console.log(this.type);
    },
    mounted(){

    },
    methods: {
        onSubmit(){
            let that = this;
            let jsonData = {
              ...this.form
            }
            let data = {
                user_phone: this.user_phone,
                user_nick: this.user_nick,
                merchant_id: this.merchant_id,
                service_type: this.service_type,
                json_data: JSON.stringify(jsonData)
            }
            this.submitLoading = true;
            servicesNew(data).then((res)=>{
                let resData = res.data.data;
                if(res.data.code == 1){
                  this.$router.push({path:'/servicesResult?id=' + resData.order_id})
                }else{
                  this.$toast(res.data.info? res.data.info:'系统错误');
                }
            })
        },
        toDetail(row){
          this.$router.push({path: row.link + this.service_type})
        },
        dateInput(row){
            this.form.battery_date = row.text;
            this.showPicker = false;
        },
        onConfirm(row){
          this.form.battery_date = row.text;
          this.showPicker = false;
        }
    }
}
</script>

<style lang='scss' scoped>
.servicesPro{
  margin: 10px;
}
.servicesProItem{
  box-shadow: 0 0 5px #ccc;
  padding: 10px;
  position: relative;
  border-radius: 5px;
  margin: 20px 0;
  h3{
    border-bottom: 1px solid #ececec;
    padding-bottom: 8px;
    line-height: 26px;
  }
  span{
    padding: 6px 12px;
    background-color: #4285f4;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    transition: background 0.3s;
    flex-shrink: 0;
    position: absolute;
    top: 10px;
    right: 10px;
  }
  .itemDesc{
    margin-top: 10px;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 10px;
    color: #333;
  }
}
</style>
